<template>
  <div id="reportes-page" class="container-fluid">
    <div id="formulario-top" class="container">
      <div class="row">
        <div id="desde" class="col-sm-2 col-sm-offset-1">
          <date-picker :date="date" :option="option2" @change="validate($event, 'desde')"
            style="width: 100%;"></date-picker>
          <span style="color: red; font-size: 10px;">{{ desdeText }}</span>
        </div>
        <div id="hasta" class="col-sm-2">
          <date-picker :date="date" :option="option" @change="validate($event, 'hasta')"
            style="width: 100%;"></date-picker>
          <span style="color: red; font-size: 10px">{{ hastaText }}</span>
        </div>
        <div class="col-sm-2">
          <select-c name="desde" id="ducto" placeholder="DUCTO" :options="ductos"
            @changeSelect="changeSelected()"></select-c>
        </div>
        <div class="col-sm-2">
          <select-c name="estacion" id="estacion" placeholder="ESTACION" :options="estacionesOps"></select-c>
        </div>
        <div id="" class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-0">
          <button id="buscar-btn" class="btn btn-default waves-effect waves-light" @click="submitInfo()"
            :class="[(desde === '' || ductoSelected === null || validation === false) ? 'disabled' : '']">
            Buscar
          </button>
        </div>
      </div>

    </div>

    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7 col-xs-12" v-show="!showDetails">
          <button class="print_btn" @click="Popup()">Imprimir</button>
          <div id="panel-body-two" class="panel-body-two" v-show="sitePdf">
            <pdf-pressure-div :duct="ductsender" :site="sitePdf" :desde="desde" :hasta="hasta" 
              chartLimit="24"
              isDetails="false"
              showViewColumn="true"
              header="Reporte de Presiones" @openDetails="openDetails($event)">
            </pdf-pressure-div>
          </div>
        </div>
        <div class="col-md-7 col-xs-12" v-show="showDetails">
          <button class="print_btn" @click="showReport()">Regresar</button>
          <div id="panel-body-two" class="panel-body-two" v-show="showDetails">
            <pdf-pressure-div :duct="ductsender" :site="siteDetailsPdf" :desde="desde" :hasta="hasta" 
              :datetimeTag="datetimeTag"
              chartLimit="7"
              isDetails="true"
              showViewColumn="false"
              header="Detalle de Presiones">
            </pdf-pressure-div>
          </div>
        </div>
        <div class="col-md-5 col-xs-12">
          <div class="panel-body">
            <table class="table">
              <thead>
                <tr>
                  <th class="nombre-alarma" colspan="7" style="height: 40px;"> Ducto: {{ this.ductoNameSelected }} </th>
                </tr>
                <tr class="text-center">
                  <th>Fecha</th>
                  <th>Nombre</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(a, key) in this.data" :key="key">
                  <td>{{ key }}</td>
                  <td>{{ pdfName(key) }}</td>
                  <td>
                    <i @click="open(key)" class="fa fa-eye view-report" aria-hidden="true" title="Ver reporte"
                      data-toggle="modal" data-target="#comentarioModal">
                    </i>
                    <i @click="downloadExcel(key)" class="fa fa-file-excel-o view-report" aria-hidden="true"
                      title="Descargar archivo Excel" data-toggle="modal" data-target="#comentarioModal">
                    </i>
                    <i @click="downloadCSV(key)" class="fa fa-download view-report" aria-hidden="true"
                      title="Descargar archivo CSV" data-toggle="modal" data-target="#comentarioModal">
                    </i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
    <button id="loading-btn-chart2" class="hidden" type="button" data-toggle="modal" data-target="#loading-modal-modal"></button>
    <modal :name="modalName" cclass="transparent">
      <loading-modal :info="info"></loading-modal>
    </modal>
  </div>
</template>

<script>
let Modal = () => import('reusable/Modal')
let LoadingModal = () => import('components/Modals/LoginModal')
//  var $ = require('jquery')
import SelectC from 'reusable/Select'
import datePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import PdfPressureDiv from 'components/Reportes/PdfPressureDiv'
import toastr from 'toastr'
import * as XLSX from 'xlsx';

export default {
  data() {
    return {
      datetimeTag: null,
      modalName: 'loading-modal',
      metaInfo: {
        meta: [
          { charset: 'utf-8' },
          { name: 'viewport', content: 'initial-scale = 1.0,maximum-scale = 1.0' }
        ]
      },
      info: {
        modalName: this.modalName
      },
      storedData: {},
      data: null,
      pushdates: [],
      lastDate: '',
      ductsender: '',
      sitePdf: null,
      siteDetailsPdf: null,
      showDetails: false,
      estacionesOps: '',
      kmFrom: 0,
      kmTo: 10000,
      objDucto: [],
      desde: '',
      hasta: '',
      ductos: [],
      section: {},
      ducto: null,
      currDucto: '',
      desdeText: '',
      hastaText: '',
      ductoSelected: null,
      ductoNameSelected: null,
      validation: false,
      date: this.$store.state.dpDate,
      option: this.$store.state.dpOpsHasta,
      option2: this.$store.state.dpOpsDesde,
    }
  },
  methods: {
    openDetails(data) {
      const key = this.ductoSelected + document.querySelector('#estacion').value.padStart(2, '0') + '_' + data.i_ts;

      if (this.storedData[key]) {
        this.siteDetailsPdf = {
          [key]: this.storedData[key]
        };
        this.showDetails = true;
        return;
      }

      this.loading();
      this.showDetails = false;

      this.$store.dispatch('LOAD_REPORTE_PRESSURE_DETAILS', {
          desde: data.i_ts,
          ducto: this.ductoSelected,
          estacion: document.querySelector('#estacion').value,
        }).then((resp) => {
          this.loading();
          if (resp.data.length === 0) {
            toastr.error('No se encontró información')
            return
          }
          const sitename = '' + Object.keys(this.data[this.lastDate])[0].trim();

          this.storedData[key] = resp.data;
          this.datetimeTag = data.i_ts;

          this.siteDetailsPdf = {
            [sitename]: resp.data
          };
          this.showDetails = true;
        }).catch(err => {
          this.loading();
          toastr.error('No se encontró información')
          console.log('Error', err);
          this.showDetails = false;
        })
    },
    loading() {
      document.querySelector('#loading-btn-chart2').click()
    },
    imgUrl(url) {
      return require(`${url}`)
    },
    getStyleColor(name) {
      const rootStyles = getComputedStyle(document.documentElement);
      const btnDefaultColor = rootStyles.getPropertyValue(name).trim();
      return btnDefaultColor;
    },
    showReport() {
      this.showDetails = false;
    },
    Popup() {
      if(!this.sitePdf) {
        return;
      }
      const btnColor = this.getStyleColor('--btn-default');
      var divToPrint = document.querySelector('.panel-body-two').innerHTML
      var mywindow = window.open('', 'Print-Window', 'height=600,width=1100')
      mywindow.document.write(`
        <html><head><title>Print</title>
        <link href="https://fonts.googleapis.com/css?family=Roboto:300,400" rel="stylesheet">
        <style>
          .mydiv{
          background-color:#fff;
          font-family: 'Roboto', sans-serif;
          }
          .mydiv div#pdf{
            max-height:200px;
            height:200px;
          }
          .mydiv div#linechart{
            display:none;
          }
          .mydiv img#leak{
              display:inline-block;
              width:115px;
            }
          .mydiv img#pem{
              padding-left: 400px;
              display:inline-block;
              width:115px;
            }
          .mydiv h4#h41{
              font-size:20px;
              font-weight:400;
              text-transform: uppercase;
              padding:0;
              margin-top:10px;
              margin-bottom:10px;
            }
          .mydiv hr#hr1{
              	background-color: #fff;
	              border-top: 2px solid ${btnColor};
            }
          .mydiv span#titles{
            color: ${btnColor};
            text-transform: uppercase;
            margin-left:4px;
          }
          .mydiv table#tableholder{
            height: 50%;
            width:100%;
            margin:0;
          }
          .mydiv thead#header{
             width:100%;
             padding:2px;
             background-color: ${btnColor};
          }
           .mydiv tr#trh{
             width:100%;
             padding:2px;
             background-color: ${btnColor};
          }
          .mydiv th#thh{
            font-size:12px;
            align:left;
            font-weight:400;
            padding:4px;
            border: 1.5px solid ${btnColor};
            color: white;
            background-color: ${btnColor};
          }
          .mydiv td#tdc{
            font-size:10px;
            font-weight:200;
            text-align:center;
            padding:2px;
            border: 0px;
          }
          .highlight {
            color: red;
          }
          @media print {
            .mydiv th#thh {
              background-color: ${btnColor} !important;
              color: black !important;
            }
            .mydiv tr#trh {
              background-color: ${btnColor} !important;
            }
            .mydiv thead#header {
              background-color: ${btnColor} !important;
            }
              .print-hidden {
                display: none;
              }
          }
        </style>
        </head>
        <body onload="window.print()">
          <div class="mydiv"> ${divToPrint} </div>
        </body>
        </html>
      `);
      mywindow.document.close()
      setTimeout(() => mywindow.close(), 200);
      return true
    },
    validate(e, d) {
      this[d] = e
      let max = this.hasta
      let min = this.desde
      if (max !== '' && (max <= min || min === '')) {
        this.desdeText = 'Este valor debe ser menor'
        this.hastaText = 'Este valor debe ser mayor'
        this.validation = false
      } else {
        this.desdeText = ''
        this.hastaText = ''
        this.validation = true
      }
    },
    changeSelected() {
      const selectElement = document.querySelector('#ducto');
      const selectedIndex = selectElement.selectedIndex;
      const selectedOption = selectElement.options[selectedIndex];
      this.ductoNameSelected = selectedOption.text;
      this.ductoSelected = selectElement.value
      this.estacionesOps = this.$store.getters.GET_OP({
        filteredBy: 'sites',
        ducto: this.ductoSelected
      })
    },
    formatDate() {
      let date = new Date().toLocaleString('es-US', {
        hour12: false
      }).split(' ')

      let time = date[1]
      let mdy = date[0].split('/')
      let month = parseInt(mdy[0])
      let day = parseInt(mdy[1])
      let year = parseInt(mdy[2])
      return `${year}-${day}-${month} ${time}`
    },
    submitInfo() {
      this.loading()
      this.storedData = {};
      if (!this.hasta) {
        this.hasta = this.formatDate()
      }
      this.showDetails = false;

      if (this.desde && this.ductoSelected && this.validation === true) {
        this.$store.dispatch('LOAD_REPORTE_PRESSURE', {
          desde: this.desde,
          hasta: this.hasta,
          ducto: this.ductoSelected,
          estacion: document.querySelector('#estacion').value,
          kmFrom: this.kmFrom,
          kmTo: this.kmTo
        }).then((resp) => {
          this.sitePdf = null;
          this.loading()
          if (resp.data.length === 0) {
            toastr.error('No se encontró información')
            return
          }
          this.data = resp.data
          // this.fillTable()
        }).catch(err => {
          toastr.error('No se encontró información')
          console.log('Error', err)
        })
      } else {
        this.loading()
      }
    },
    identifyContinousPressure(array) {
      let count = 0;
      let markSamePressure = [];
      const result = array.map((item, index) => {
        if (index > 0 && item.p === array[index - 1].p) {
          count++;
        } else {
          count = 1;
        }
        
        if (count >= 2) {
          if (!array[index - 1].samePressure) {
            markSamePressure.push(index - 1);
          }
          markSamePressure.push(index);
        }
        return { ...item, samePressure: false, groupStart: '', groupEnd: '' };
      });

      markSamePressure.forEach(index => {
        result[index].samePressure = true;
      });

      // count = 0;
      // let groupStart = '';
      // let groupEnd = '';
      // for (let i = 0; i < result.length; i++) {
      //   if (result[i].samePressure) {
      //     count++;
      //     groupEnd = result[i].i_ts;
      //   } else {
      //     count = 1;
      //     groupStart = result[i].i_ts;
      //   }

      //   if (count >= 2) {
      //     for (let j = i - count; j < i + count; j++) {
      //       result[j].groupStart = groupStart;
      //       result[j].groupEnd = groupEnd;
      //     }
      //   }
      // }

      return result;
    },
    open(date) {
      this.showDetails = false;
      this.lastDate = date;
      this.ductsender = this.ductoSelected
      const sitename = '' + Object.keys(this.data[date])[0].trim();
      const arrayData = this.data[date][sitename];
      const pdfData = this.identifyContinousPressure(arrayData);
      this.sitePdf = {
        [sitename]: pdfData
      }
    },
    pdfName(date) {
      var sitename = '' + Object.keys(this.data[date])[0].trim();
      sitename = sitename.replace(/[^a-zA-Z0-9]/g, '_');
      return date.replaceAll('-', '_').replaceAll('__', '_') + '_' + sitename;
    },
    downloadExcel(date) {
      const selectedStation = document.querySelector('#estacion').value;
      const sitename = Object.keys(this.data[date])[0];
      const pageName = this.ductoSelected + selectedStation.padStart(2, '0') + '_' + date
      const excelName = this.pdfName(date);
      const arrayData = this.data[date][sitename];
      const excelData = arrayData.map(item => ({
        'Fecha de Solicitud': item.i_ts,
        'Latitud': item.lat,
        'Longitud': item.lon,
        'Presión': item.p
      }));

      // Create a new workbook and add the data
      const worksheet = XLSX.utils.json_to_sheet(excelData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, pageName);

      // Generate a file name
      const fileName = excelName + '.xlsx';

      // Write the workbook to a file
      XLSX.writeFile(workbook, fileName);
    },
    downloadCSV(date) {
      const sitename = Object.keys(this.data[date])[0];
      const csvName = this.pdfName(date);
      const arrayData = this.data[date][sitename];
      const csvData = arrayData.map(item => ({
        'Fecha de Solicitud': item.i_ts,
        'Latitud': item.lat,
        'Longitud': item.lon,
        'Presión': item.p
      }));

      const worksheet = XLSX.utils.json_to_sheet(csvData);
      const csv = XLSX.utils.sheet_to_csv(worksheet);

      // Add BOM for UTF-8 encoding
      const bom = '\uFEFF';
      const blob = new Blob([bom + csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = csvName + '.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
  components: {
    SelectC,
    datePicker,
    PdfPressureDiv,
    Modal,
    LoadingModal
  },
  mounted() {
    this.$store.dispatch('LOAD_OPS')
      .then(resp => {
        this.ductos = this.$store.getters.GET_OP({
          filteredBy: 'section_name'
        })
      })
      .catch(err => {
        console.log('Error', err)
      })
  }
}
</script>

<style lang="scss" scoped>
@import "~varmix";

.row {
  margin: 0;
  padding: 0;
}

.col-md-6,
.col-xs-12 {
  padding: 0px !important;
}

.container-fluid {
  background-color: white;
  width: 100%;
  padding: 0;
  margin: 0;
}

table,
.panel-body {
  tr {
    margin: 0px !important;
    padding: 0px !important;
  }

  overflow-y: scroll;
  overflow-x:hidden;
  max-height: 65vh; // width: 50vw;
  height: 100%;
  padding: 0px;
  margin: 0px;

  .info {
    td {
      background-color: $bg;

    }
  }

  th {
    text-align: left;
    padding-left: 25px;

    @include cMax(415px) {
      font-size: 12px;
    }
  }

  td {
    vertical-align: inherit;

    i {
      color: $inactive;
      cursor: pointer;

      &:hover {
        color: $amarilloC;
      }
    }

    .view-report {
      padding-left: 10px;
    }
  }


  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }

  .panel-body {
    padding: 0px;
  }

  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}


.panel-body-two {
  overflow: scroll;
  overflow-x: hidden;
  max-height: 65vh;
  height: 99%;
  padding: 3px 0;
  margin: 0;

  .info {
    td {
      background-color: $bg;
    }
  }

  th {
    text-align: left;
    padding-left: 25px;

    @include cMax(415px) {
      font-size: 12px;
    }
  }

  td {
    text-align: left;
    padding-left: 25px;

    i {
      color: $inactive;
      cursor: pointer;

      &:hover {
        color: $amarilloC;
      }
    }
  }

  .nombre-alarma {
    background-color: $amarilloC;
    color: white;
  }

  .panel-body {
    padding: 0;
  }

  .panel-title {
    @include cMax(415px) {
      font-size: 12px;
    }
  }
}

.btn-default {
  background: $amarilloO;

  &:hover,
  &:focus,
  &:active {
    background: $amarilloC !important;
  }
}

#pagebreak {
  display: block;
  page-break-after: always;
}

#reportes-page {
  padding-top: 70px;
  background-color: $bg;
  height: 100vh;

  #formulario-top {
    height: 20vh;
    padding-top: 5vh;

    @include celphone {
      height: 45vh;
    }
  }

}

// range
.color-2 .irs-bar,
.color-2 .irs-bar-edge {
  background: red;
}

.error {
  border: 2px solid red !important;
}

.print_btn {
  width: 100%;
  background-color: $amarilloC;
  padding: 8px;
  font-weight: 500;
  color: white;
}

.print_btn:hover {
  background-color: $amarilloL;

}

.print_btn:active {
  background-color: gray;
  color: white;
}

#loading-modal-modal {
  background-color: $loading-modal-bg-color;
}
</style>



// WEBPACK FOOTER //
// Pressure.vue?5c342c86